import { TimeOption } from './time-option';

export class DayTimeOptions {
    datetime: Date;
    options: TimeOption[] = [];
}
